import React, {useEffect, useState} from 'react'
import {Row} from 'antd'
import {useTranslation} from "react-i18next"
import Constructor from "../index";
import {getTariffRates} from "../../NRI/TariffRate/store/actions";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import '../style.css'
import Back from "../back";

const ConstructorResourceBase = () => {
    const [viewBlock, setViewBlock] = useState('default')
    const {t} = useTranslation(['kit'])
    const routeParams = useParams()
    const id = routeParams?.id
    const dispatch = useDispatch()
    const tariffRateList = useSelector(state => state.tariffRateReducer.list)
    const year = new Date().getFullYear()

    useEffect(() => {
        if (tariffRateList.length === 0) {
            dispatch(getTariffRates(year))
        }
    }, [])

    return (
        <div className='designer'>
            {viewBlock === "default" &&
                <Row align='middle' justify='space-between'>
                    <Back url={'/'} title={t('kit:confExitConstructor')}/>
                {/*<BrdCrumb routes={[['', t("common:back")]]}/>*/}
                <h3 className="title-name" style={{}}>
                    Конструктор, ресурсный метод. {(id) ? t('kit:editCustomObj') : t('kit:createCustomObj')}
                </h3>
                <div/>
            </Row>}
            <Constructor
                setViewBlock={setViewBlock}
                viewBlock={viewBlock}
                isResource={true}
                id={id}
            />
        </div>
    )
}

export default ConstructorResourceBase
